module.exports = __webpack_public_path__ + "static/media/17_BOJO_MEIA_TACA_LISO_01.7e0d8c91.jpg";